export default {
    navBar: {
        home: 'الرئيسية', // Home
        movers: 'المتحركات', // Movers
        signals: 'الزخم', // Momentum
        myWatchlist: 'متابعاتي', // Watchlist (Shorthand: قوائم المتابعة)
        calendars: 'التقويمات', // Calendars
        settings: 'الإعدادات', // Settings
        socialBuzz: 'الرائجة', // Trending
        sectors: 'القطاعات', // Sectors
        stocksFeed: 'أخباري', // My newsfeed (Shorthand: موجز الأخبار)
        macroFeed: 'أخبار السوق', // Market news
        top10: 'الأعلى 10', // Top 10 (Shorthand: توب 10)
        dividends: 'الأرباح', // Dividends (Shorthand: التوزيعات)
        top10Pro: 'السوق', // Market (Performance)
        indices: 'مقتنيات المؤشرات', // Indices holdings
        institutional: 'مقتنيات المؤسسات', // Institutional holdings
        contactUs: 'اتصل بنا', // Contact us
        termsOfUse: 'شروط الاستخدام', // Terms of use
        selectLanguage: 'اختر لغة النظام', // Select system's language
        heatmap: 'الخريطة الحرارية', // Heatmap
        new: 'جديد', // New (Shorthand: ج)
        soon: 'قريباً' // Soon (Shorthand: ق)
    },
    signals: {
        lowhigh: '52 أسبوع: أدنى/أعلى', // 52 weeks low/high
      low52: '52 الأدنى', // 52 low
      high52: '52 الأعلى', // 52 high
        ath: 'أعلى قيمة على الإطلاق', // All time high (Shorthand: ق.ع.الإطلاق)
        note: 'بناءً على يوم التداول الأخير' // Based on the last trading day
    },
    contactUs: {
        title: 'اتصل بنا', // Contact us
        text: 'نحن ملتزمون بتزويدك بأكثر المعلومات جودة وأهمية في أقصر وقت ممكن. نرحب بأي أفكار، اقتراحات للتحسين، أو تقارير أخطاء قد تكون لديك.',
        name: 'الاسم', // Name
        email: 'البريد الإلكتروني', // Email (Shorthand: الإيميل)
        message: 'الرسالة', // Message
        privacy: 'خصوصيتك مهمة بالنسبة لنا. تهدف المعلومات للرد على طلبك ولن يتم نقلها لطرف ثالث أو استخدامها لإرسال رسائل غير مرغوب فيها.'
    },
    errors: {
        noContentMessage: 'الرجاء كتابة رسالة', // Please write down a message
        invalidEmail: 'الرجاء كتابة عنوان بريد إلكتروني صالح', // Please type a valid email address
        emptyCalendar: 'لا توجد أحداث للفترة المختارة', // There are no events for the selected period
        emptyWatchlist: 'قائمة المتابعة فارغة', // The watchlist is empty
        emptyFavoriteList: 'قائمة المفضلة فارغة' // The favorites list is empty
    },
    login: {
        trialEnded: {
            title: 'انتهت الفترة التجريبية لـ EZtrade', // Your EZtrade trial has ended
            explain: (price) => `<b>شكراً لتجربتك منصتنا!</b>
              <br/>للتأكد من عدم تفويتك لفرص سوق رائعة، ابدأ حسابك المميز مقابل $${price} شهرياً فقط.<br/>
              إذا كانت لديك أية مشاكل أو استفسارات، فلا تتردد في التواصل معنا عبر <a class="mbpLink" href="mailto:hello@EZtrade">hello@EZtrade</a>.`,
            signupButton: 'التسجيل للاشتراك' // Signup for subscription
        }
    },
    languages: {
         en: 'الإنجليزية', // English
        he: 'العبرية', // Hebrew (עברית)
    it: 'الإيطالية', // Italiano
    ar: 'العربية', // العربية
    },
    watchlist: {
        numberOfSymbols: 'عدد الرموز', // Number of symbols
        removeSymbols: 'إزالة المختارة' // Remove selected
    },
    filters: {
        filterList: 'تصفية القائمة', // Filter list
        index: 'المؤشر', // Index
        sector: 'القطاع', // Sector
        industry: 'الصناعة', // Industry
        sectors: 'القطاعات', // Sectors
        industries: 'الصناعات', // Industries
        searchType: '(يمكنك الكتابة والبحث)', // (You can type and search)
        pe: 'مكرر الأرباح', // P/E (Shorthand: م.أ)
        marketCap: 'القيمة السوقية', // Market cap. (Shorthand: ق.س)
        priceChange: 'تغير السعر', // Price change
        moreThan: 'أكثر من', // More than
        lessThan: 'أقل من', // Less than
        andMore: 'وأعلى', // and above
        andLess: 'وأقل', // and less
        years: 'سنوات', // years
        typeAndEnter: 'كتابة حرة (اضغط Enter للإنهاء)', // Free typing (press Enter to end)
        dividendConsecutiveYears: 'سنوات متتالية لتوزيع الأرباح', // Consecutive years of div. payout
        dividendPayoutRatio: 'نسبة توزيع الأرباح', // Dividend payout ratio (Shorthand: ن.ت.أ)
        dividendYield: 'عائد الأرباح', // Dividend yield (Shorthand: ع.أ)
        dividendFrequency: 'تكرار توزيع الأرباح', // Dividend frequency
        dividendFrequencyList: [{
            label: 'ربع سنوي', // Quarterly
            value: 'quarterly'
        }, {
            label: 'نصف سنوي', // Semi-yearly
            value: 'semiYearly'
        }, {
            label: 'سنوي', // Yearly
            value: 'yearly'
        }],
        marketCapsList: [
            {
                label: 'قيمة متناهية الصغر ( < $250M)', // Micro-Cap
                value: 'microCap'
            },
            {
                label: 'قيمة صغيرة ($250M - $2B)', // Small-Cap
                value: 'smallCap'
            },
            {
                label: 'قيمة متوسطة ($2B - $10B)', // Mid-Cap
                value: 'midCap'
            },
            {
                label: 'قيمة كبيرة ($10B - $200B)', // Large-Cap
                value: 'largeCap'
            },
            {
                label: 'قيمة ضخمة ( > $200B)', // Mega-Cap
                value: 'megaCap'
            }
        ],
        select: 'اختار', // Select
        seeNews: 'مشاهدة الأخبار المصفاة', // See filtered news
        newFilter: 'العودة إلى الفلتر', // Back to filter
        resetFilter: 'إعادة تعيين الفلتر', // Reset filter
        applyFilter: 'تطبيق الفلتر', // Apply filter
        closeFilter: 'إغلاق', // Close
        results: 'النتائج', // Results
        fount: 'تم العثور على', // found
        symbol: 'الرمز', // Symbol
        periods: [ // Periods
            { value: '1D', label: 'يوم' }, // 1D
            { value: '5D', label: '5 أيام' }, // 5D
            { value: '1M', label: 'شهر' }, // 1M
            { value: '6M', label: '6 أشهر' }, // 6M
            { value: 'YTD', label: 'منذ بداية العام' }, // YTD (Shorthand: م.ب.ع)
            { value: '1Y', label: 'سنة' }, // 1Y
            { value: '3Y', label: '3 سنوات' } // 3Y
        ],
    },
    search: {
        tabs: {
            freeSearch: 'بحث حر', // Free search
            filter: 'تصفية بالمعايير', // Filter by parameters (Shorthand: فلترة بـ)
            trending: 'الرموز الرائجة' // Trending symbols
        },
        filter: {
            name: 'الاسم', // Name
            price: 'السعر', // Price
            mustSelectASector: 'يجب اختيار قطاع أو صناعة. يمكنك البحث عن صناعة بالكتابة.', // Must select a sector/industry
            sectorSelection: 'اختيار القطاع', // Sector selection
            industrySelection: 'اختيار الصناعات (يمكنك الكتابة والبحث)', // Industries selection
            marketCapSelection: 'اختيار القيمة السوقية', // Market Cap. selection
            priceChange: 'تغير السعر', // Price change
            moreThan: 'أكثر من', // More than
            lessThan: 'أقل من', // Less than
            search: 'تصفية', // Filter (Shorthand: فلتر)
            pe: 'مكرر الأرباح', // P/E (Shorthand: م.أ)
            seeNews: 'مشاهدة الأخبار المصفاة', // See filtered news
            newFilter: 'العودة إلى الفلتر', // Back to filter
            resetFilter: 'إعادة تعيين الفلتر', // Reset filter
            results: 'النتائج', // Results
            fount: 'تم العثور على', // found
            symbol: 'الرمز', // Symbol
            periods: [
                { value: '1D', label: 'يوم' },
                { value: '5D', label: '5 أيام' },
                { value: '1M', label: 'شهر' },
                { value: '6M', label: '6 أشهر' },
                { value: 'YTD', label: 'م.ب.ع' },
                { value: '1Y', label: 'سنة' },
                { value: '3Y', label: '3 سنوات' }
            ],
            sector: 'القطاع', // Sector
            industry: 'الصناعة', // Industry
            marketCap: 'القيمة السوقية', // Market cap. (Shorthand: ق.س)
            marketCapRangeValues: [
                { value: '<500m', label: 'أقل من $500M' },
                { value: '500m-1b', label: '$500M-$1B' },
                { value: '1b-10b', label: '$1B-$10B' },
                { value: '10b-200b', label: '$10B-$200B' },
                { value: '>200b', label: 'أعلى من $200B' }
            ],
            marketCapValues: [
                { value: '<10m', label: 'أقل من $10M' },
                { value: '>10m', label: 'أعلى من $10M' },
                { value: '>100m', label: 'أعلى من $100M' },
                { value: '>1b', label: 'أعلى من $1B' },
                { value: '>10b', label: 'أعلى من $10B' },
                { value: '>100b', label: 'أعلى من $100B' }
            ],
            performance: 'الأداء', // Performance
        }
    },
    tags: {
        quickLook: 'نظرة سريعة', // Quick look
        close: 'إغلاق', // Close
        topGainers: 'أكثر الرابحين', // Top gainers
        topActive: 'أكثر نشاطاً', // Top active
        topLosers: 'أكثر الخاسرين', // Top losers
        moreSymbols: 'المزيد', // More
        tradingHalt: 'وقف التداول', // Trading halt
        tradingResumption: 'استئناف التداول', // Trading resumption
        signal: 'إشارة', // Signal
        trade: 'صفقة', // Trade
        taReview: 'مراجعة فنية', // Technical review
        moreEvents: 'المزيد من الأحداث', // More events
        hideSymbols: 'إخفاء', // Hide
        insiders: 'تداولات المطلعين', // Insider's trade
        pressRelease: 'بيان صحفي', // Press release (Shorthand: ب.ص)
        shouldKnowNotificationTitle: 'يجب أن تعرف', // You should know
        marketOpen: 'السوق مفتوح', // The market is open
        marketClose: 'السوق مغلق', // The market is closed
        preMarket: 'ما قبل السوق', // Pre-market
        postMarket: 'ما بعد السوق' // Post-market
    },
    buttons: {
        continueToApp: 'العودة إلى EZtrade', // Back to EZtrade
        close: 'إغلاق', // Close
        send: 'إرسال', // Send
        en: 'الإنجليزية', // English
        he: 'العبرية', // Hebrew
        filterStocks: 'تصفية الأسهم', // Filter stocks
        editColumns: 'تعديل الأعمدة', // Edit columns
        seeFullDetails: 'مشاهدة التفاصيل الكاملة', // See full details
        showMoreInfo: 'عرض المزيد من المعلومات', // Show more info
        hideMoreInfo: 'إخفاء المزيد من المعلومات', // Hide more info
        approveTerms: 'أوافق على شروط الخدمة', // I approve the terms of service
        moveToPortfolio: 'انقر هنا لإضافة رموز', // Click here to add symbols
        moveToWatchlist: 'النقل إلى قائمة المتابعة', // Move to watchlist
        addToPortfolio: 'إضافة إلى قائمة المتابعة', // Add to watchlist (Portfolio here means Watchlist)
        removeFromPortfolio: 'إزالة من قائمة المتابعة', // Remove from watchlist
        addToPortfolioShort: '+', // +
        removeFromPortfolioShort: '-', // -
        readMore: 'قراءة المزيد', // Read more
        readLess: 'قراءة أقل' // Read less
    },
    feeds: {
        viewImage: 'عرض الصورة', // View image
        viewLink: 'عرض الرابط', // View link
        stocksFeed: 'أخباري', // My newsfeed
        stocksFavoriteFeed: 'أخبار المفضلة', // My favorite newsfeed
        macroFeed: 'أخبار السوق', // Market news
        backToPortfolio: 'العودة إلى قائمة المتابعة', // Back to watchlist
        filter: 'تصفية الأخبار', // Filter news
        breakingNews: 'أخبار عاجلة', // Breaking news (Shorthand: عاجل)
        wiim: 'الأسهم المتحركة', // Stocks on the move
        filters: {
            all: 'الكل', // All
            tradesAndSignals: 'صفقات وإشارات', // Trades & signals
            priceTargets: 'المحللين', // Analysts (Price Targets)
            pr: 'بيان صحفي', // Press release (Shorthand: ب.ص)
            insiders: 'تداولات المطلعين', // Insider's trades
            hedgeFunds: 'صناديق التحوط', // Hedge funds
            earnings: 'الأرباح', // Earnings
            sec: 'SEC', // SEC
            financialMedia: 'إعلام مالي', // Financial media
            analysts: 'BZ Wire' // Analysts (BZ wire)
        }
    },
    tables: {
        symbol: 'الرمز', // Symbol
        '1d' : 'يومي %', // Day %
        '5d': '5 أيام %', // 5D %
        '10d': '10 أيام %', // 10D %
        '1m': 'شهر %', // 1M %
        '6m' : '6 أشهر %', // 6M %
        'q' : 'ربع سنوي %', // Quarter %
        ytd: 'م.ب.ع %', // YTD %
        '1y' : 'سنة %', // 1Y %
        '3y' : '3 سنوات %', // 3Y %
        '5y' : '5 سنوات %', // 5Y %
        sector: 'القطاع', // Sector
        industry: 'الصناعة', // Industry
        marketCap: 'ق.س', // Market cap. (Shorthand)
        pe: 'م.أ', // P\E (Shorthand)
        nextDividendExDate: 'تاريخ استحقاق الأرباح القادم', // Next div date (Shorthand: ت.ا.الأرباح قادم)
        datePublished: 'تاريخ النشر', // Date published
        lastUpdate: 'تاريخ التحديث', // Date updated
        numOfFollowups: 'عدد المتابعات', // # of followups
    },
    trades: {
        percentChange: 'تغير %', // % change
        percentChangeTooltip: 'نسبة التغير في سعر السهم منذ نشر الصفقة', // Stock's price percent change since a trade was published
        since: 'منذ', // since
        gained: 'ارتفع', // gained
        lost: 'انخفض', // lost
        dateAdded: 'تاريخ النشر', // Publishing date
        lastUpdate: 'تاريخ التحديث', // Update date
        numberOfFollowups: '# متابعات', // # followups
        published: 'نُشر', // Published
        updated: 'حُدِّث', // Updated
        daysAgo: 'أيام مضت', // days ago
        change: 'تغير %', // Cng. %
        week1: 'أسبوع 1', // 1 week
        week2: 'أسبوعان', // 2 weeks
        week3: '3 أسابيع', // 3 weeks
        week4: '4 أسابيع', // 4 weeks
        week5: '5 أسابيع', // 5 weeks
        week6: '6 أسابيع', // 6 weeks
        tradeHasFollowups: (num) => `لهذه الصفقة <span class="highlight">${num}</span> متابعات.`, // This trade has [num] followups.
        sinceTradeWasPublished: (symbol) => `منذ نشر هذه الصفقة، سعر <b>${ symbol }</b>`, // Since this trade was published, [symbol]'s price
    },
    messages: {
        followup: 'متابعة الصفقة', // Trade follow up
        enlargeImage: 'انقر لتكبير الصورة', // Click to enlarge image
        welcomeBanner: 'أهلاً بك في EZtrade!', // Welcome to EZtrade!
        languageBanner: 'الرجاء اختيار لغة النظام:', // Please choose system's language:
        topMktCap: 'تشير هذه الصفحة إلى الشركات التي يبلغ حجم تداولها +150 ألف', // This page refers to companies with a volume of +150K
        topVolume: 'تشير هذه الصفحة إلى الشركات التي يبلغ حجم تداولها 150 ألف وأكثر', // This page refers to companies with a volume of 150K and above
        peersExpl: (symbol) => `الأسهم التي تم تقييمها وفقًا لعدد من العوامل ولها قيمة سوقية مماثلة لـ ${symbol}`, // Stocks that have been evaluated...
        shortInstructions: 'يقدم لك EZtrade أخبار وأحداث سوق الأسهم في الوقت الفعلي تلقائيًا. لإنشاء موجز الأخبار الخاص بك، أضف رموزًا إلى قائمة المتابعة الخاصة بك بسهولة. يمكنك إضافة وإزالة الرموز في أي وقت.', // EZtrade brings you real-time stock market news...
        favoriteInstruction: 'ضع علامة النجمة على الرموز في قائمة المتابعة الخاصة بك لإنشاء موجز أخبار مركَّز', // Mark symbols on your watchlist with a star...
        contactMessageSentTitle: 'تم إرسال رسالتك!', // Your message has been sent!
        contactUsThankYou: 'شكراً لرسالتك، سنرد عليك قريباً', // Thank you for your message, we will respond shortly
        watchlist: 'ابحث عن الرموز وأضفها إلى قائمة المتابعة الخاصة بك. سيسمح لك بناء قائمة متابعة بتلقي الأخبار والأحداث ذات الصلة بك قبل أي شخص آخر.', // Search for symbols and add them to your watchlist...
        trendingStocks: 'الأسهم التي تم ذكرها بشكل كبير على وسائل التواصل الاجتماعي. يمكن أن تشير التغيرات في عدد مرات ذكر السهم إلى اتجاه متزايد على منصات التواصل الاجتماعي.', // Highly mentioned stocks on social media...
        exDiv: 'في تاريخ الاستحقاق (Ex-dividend date)، ينخفض سعر السهم بمقدار الأرباح، وفقط أولئك الذين يملكون السهم في تاريخ الاستحقاق هم من يحصلون على الأرباح.', // On the ex-dividend date...
        sectors: 'شاهد أداء قطاعات السوق المختلفة. بالنقر على اسم القطاع يمكنك عرض الرموز التي يتضمنها وفرزها حسب معايير مختلفة.' // View the performance of the various market sectors...
    },
    symbolSearch: {
        frequentlySearched: 'الرموز الأكثر بحثاً', // Frequently searched symbols
        inputLabel: 'البحث عن رموز', // Search symbols
        inputLabelNote: 'يمكنك البحث عن عدد من الرموز أو أسماء الأسهم مفصولة بمسافة.', // You can search a number of symbols or equity names seperated by the space key.
        noResults: 'لم يتم العثور على نتائج لـ' // No results were found for
    },
    settingsPage: {
        titles: {
            title: 'الإعدادات', // Settings
            notificationSettings: 'إعدادات الإشعارات', // Notification settings
            userSettings: 'إعدادات المستخدم', // User settings
            systemSettings: 'إعدادات النظام', // System settings
            dangerZone: 'منطقة الخطر', // Danger zone
            subscriptionSettings: 'إعدادات الاشتراك', // Subscription settings
            languageSettings: 'إعدادات اللغة', // Language settings
            systemLanguage: 'لغة النظام الافتراضية', // Default system's language
            newsLanguages: 'لغات الأخبار', // News languages
            verifyClosingOfAccount: 'الموافقة على إغلاق الحساب' // Approve account closing
        },
        buttons: {
            close: 'إغلاق', // Close
            saveLanguageSettings: 'حفظ إعدادات اللغة', // Save language settings
            saveNotifications: 'حفظ إعدادات الإشعارات', // Save notification settings
            saveAccount: 'حفظ إعدادات الحساب', // Save account settings
            closeAccount: 'إغلاق الحساب', // Close account
            logout: 'تسجيل الخروج', // Logout this account
            subscribeNow: 'اشترك الآن في EZtrade المميز', // Subscribe to EZtrade premium now
            subscribe: 'اشتراك', // Subscribe
            approveClosingOfAccount: 'أنا أفهم، أغلق الحساب' // I understand, close the account
        },
        tabs: {
            account: 'الحساب', // Account
            notifications: 'الإشعارات', // Notifications
        },
        notes: {
            dataUpdate: 'تم تحديث البيانات', // Data was updated
            updatePassword: 'الرجاء تحديث كلمة المرور', // Please update password
            account: 'قم بتعيين تفاصيل حسابك واشتراكك. يمكنك إلغاء حسابك في أي وقت.', // Set you account details...
            notifications: 'قم بتعيين إشعارات البريد الإلكتروني. يمكنك الحصول عليها في الوقت الفعلي، كملخص في وقت محدد (إذا وجدت) أو إيقاف تشغيلها.', // Set email notifications...
            googleAuth: 'لقد سجلت في EZtrade باستخدام حساب Google الخاص بك. إذا غيرت عنوان بريدك الإلكتروني، فلن تتمكن من تسجيل الدخول باستخدام Google مرة أخرى.', // You have signed up...
            verifyClosingOfAccount: 'الرجاء الموافقة على إغلاق هذا الحساب. لن تتمكن من تلقي أي إشعارات أو خدمات أخرى، وتسجيل الدخول إلى هذا الحساب، وستتوقف أي مدفوعات.', // Please approve the closing of this account...
            expiration: (date, days) => {
                return `حسابك التجريبي سينتهي خلال <b>${days}</b> أيام في ${date}.<br/>سجل في خطة EZtrade المميزة مقابل $14.99 شهرياً فقط - سعر إطلاق لمرة واحدة!` // Your trial account will end...
            }
        },
        account: {
            labels: {
                systemTheme: 'لون النظام', // System color
                lightMode: 'الوضع الفاتح', // Light mode
                darkMode: 'الوضع الداكن', // Dark mode
                firstName: 'الاسم الأول', // First name
                lsatName: 'الاسم الأخير', // Last name
                password: 'كلمة مرور جديدة', // New password
                email: 'البريد الإلكتروني', // Email
                subscriptionDetails: 'تفاصيل الاشتراك', // Subscription details
                cancelSubscription: 'إلغاء الاشتراك', // Cancel subscription
                updatePaymentCard: 'تحديث طريقة الدفع', // Update payment method
                subscriptionPrice: 'سعر الاشتراك', // Subscription price
                nextPayment: 'تاريخ الدفعة القادمة' // Next payment date
            },
        },
        notificationLabels: {
            portfolio: 'إشعارات قائمة المتابعة', // Portfolio notifications
            breakingNews: 'أخبار عاجلة', // Breaking news (Shorthand: عاجل)
            vip: 'شخصيات هامة', // VIP
            oilGas: 'النفط والغاز', // Oil & gas
            banks: 'البنوك', // Banks
            commodities: 'السلع', // Commodities
            econData: 'بيانات اقتصادية', // Economic data (Shorthand: ب.اقتصادية)
            emailNotifications: 'إشعارات البريد الإلكتروني', // Email notifications
            browserNotifications: 'إشعارات المتصفح', // Browser notifications
            soundNotifications: 'إشعارات صوتية' // Sound notifications
        },
        notificationPeriodLabels: {
            none: 'لا شيء', // None
            realTime: 'وقت فعلي', // Real-time
            five_min: 'كل 5 دقائق', // Every 5 minutes
            fifteen_min: 'كل 15 دقيقة', // Every 15 minutes
            thirty_min: 'كل 30 دقيقة', // Every 30 minutes
            fortyfive_min: 'كل 45 دقيقة', // Every 45 minutes
            sixty_min: 'كل ساعة' // Every hour
        }
    },
    symbolPage: {
        moreStocks: 'قد تكون مهتماً بهذه الأسهم', // Stock you maybe interested in
        findMoreStocks: 'البحث عن أسهم مثيرة للاهتمام', // Find interesting stocks
        findMoreStocksText: (symbol) => `ابحث عن أسهم مثيرة للاهتمام مرتبطة بـ <b>${symbol}</b> بناءً على الأداء والقيمة السوقية المماثلة.`, // Find interesting stocks related to [symbol]...
        clickToFindMoreStocks: 'انقر هنا للبحث عن المزيد من الأسهم', // Click here to find more stocks
        performanceOverTime: 'تغير السعر عبر الزمن', // Price change over time
        epsNote: 'قد يكون الاختلاف بين ربحية السهم (EPS)، كما تم حسابها في صفحة الأسهم لدينا، وكذلك في معظم المواقع المالية الأخرى، بسبب حقيقة أن صفحة الأسهم تشير إلى الربح المحاسبي، والذي يشمل المصاريف والإيرادات لمرة واحدة غير الممثلة في رأي إدارة الشركة. في حين أن أداء الشركة عادة ما يظهر "الربح المعدل"، أي بدون المصاريف والإيرادات لمرة واحدة، كما حددتها إدارة الشركة', // The difference between the EPS...
        pe: 'م.أ', // P/E (Shorthand)
        eps: 'ربحية السهم', // EPS (Shorthand: ر.س)
        nextEarnings: 'تاريخ الأرباح القادم', // Next earnings date
        releaseTime: 'وقت الإصدار', // Release time
        estimatedEps: 'ربحية السهم المقدرة', // Estimated EPS (Shorthand: ر.س م.)
        nextDividend: 'الأرباح القادمة', // Next dividend
        ma50: 'المتوسط المتحرك 50', // MA50 (Shorthand: م.م 50)
        ma200: 'المتوسط المتحرك 200', // MA200 (Shorthand: م.م 200)
        ema20D: 'المتوسط المتحرك الأسي 20', // EMA20 (Shorthand: م.م.أ 20)
        sma50D: 'المتوسط المتحرك البسيط 50', // SMA50 (Shorthand: م.م.ب 50)
        sma200D: 'المتوسط المتحرك البسيط 200', // SMA200 (Shorthand: م.م.ب 200)
        volumeTrend: 'اتجاه الحجم 5 أيام', // 5D Volume trend
        below: 'أدنى', // below
        above: 'أعلى', // above
        fiftyTwoWeeksHigh: '52 أسبوع أعلى', // 52W high (Shorthand: 52 أ.أ)
        fiftyTwoWeeksLow: '52 أسبوع أدنى', // 52W low (Shorthand: 52 أ.أ)
        yearlyRange: 'النطاق السنوي', // Yearly range
        atrTrend: 'اتجاه ATR', // ATR trend
        atrPercent: 'ATR %', // ATR%
        relVol: 'حجم نسبي', // Rel. volume (Shorthand: ح.ن)
        rsi: 'مؤشر RSI', // RSI (Shorthand)
        macd: 'مؤشر MACD', // MACD (Shorthand)
        obvTrend: 'اتجاه OBV', // OBV trend
        exDate: 'تاريخ الاستحقاق', // Ex-Date
        paymentDate: 'تاريخ الدفع', // Payment date
        nextSplitDate: 'تاريخ التجزئة القادم', // Next split date
        splitRatio: 'نسبة التجزئة', // Split ratio
        name: 'اسم الشركة', // Company name
        about: 'عن الشركة', // About the company
        marketCap: 'ق.س', // Market cap (Shorthand)
        volume: 'الحجم', // Volume
        unusualVolume: 'أعلى من المتوسط', // Above avg. (Unusual Volume)
        avgVolume: 'متوسط الحجم', // Avg. volume (Shorthand: م.ح)
        price: 'السعر', // Price
        symbol: 'الرمز', // Symbol
        sector: 'القطاع', // Sector
        industry: 'الصناعة', // Industry
        sharesOutstanding: 'الأسهم القائمة', // Shares outstanding (Shorthand: أ.ق)
        dailyRange: 'النطاق اليومي', // Daily range
        fiftyTwoWeeks: '52 أسبوع', // 52 weeks
        previousClose: 'الإغلاق السابق', // Previous close
        TYRevenueChange: 'تغير الإيرادات 3 سنوات', // 3Y revenue change
        TYEPSChange: 'تغير ربحية السهم 3 سنوات', // 3Y EPS change
        tabs: {
            overview: 'نظرة عامة', // Overview
            news: 'الأخبار', // News
            chart: 'الرسم البياني', // Chart
            financials: 'البيانات المالية', // Financials (Shorthand: المالية)
            performance: 'الأداء', // Performance
            insiders: 'المطلعون' // Insiders
        }
    },
    chart: {
        periods: {
            '1d': 'يوم', // 1D
            '5d': '5 أيام', // 5D
            '10d': '10 أيام', // 10D
            '1m': 'شهر', // 1M
            '6m': '6 أشهر', // 6M
            'ytd': 'م.ب.ع', // YTD
            '1y': 'سنة', // 1Y
            '3y': '3 سنوات', // 3Y
            '5y': '5 سنوات', // 5Y
            'max': 'الحد الأقصى' // Max
        },
        ma: 'المتوسطات المتحركة', // Moving Averages
        indexCompare: 'مقارنة بالمؤشر', // Compare index
        tooltip: {
            change: 'التغير', // Change
            volume: 'الحجم', // V
            open: 'الافتتاح', // O
            close: 'الإغلاق', // C
            high: 'الأعلى', // H
            low: 'الأدنى', // L
            price: 'السعر' // Price
        }
    },
    financials: {
        note: 'يعرض فلتر (شهري) التغير عن الربع السابق، بينما يعرض فلتر (سنوي) التغير عن الربع نفسه في العام السابق.', // The monthly filter displays the change from the previous quarter...
        periodChange: 'تغير %', // Change %
        yoy: 'سنوياً', // YoY (Year-over-Year)
        quarterly: 'ربع سنوي', // Quarterly
        incomeStatement: 'قائمة الدخل', // Income statement
        balanceSheet: 'الميزانية العمومية', // Balance sheet (Shorthand: م.عمومية)
        cashFlowStatement: 'قائمة التدفقات النقدية', // Cash flow statement (Shorthand: ت.نقدية)
        revenue: 'الإيرادات', // Revenue
        operatingExpenses: 'المصاريف التشغيلية', // Operating expenses (Shorthand: م.تشغيلية)
        netIncome: 'صافي الدخل', // Net income (Shorthand: ص.دخل)
        netProfitMargin: 'هامش الربح الصافي', // Profit margin (Shorthand: هـ.ص.ر)
        eps: 'ر.س', // EPS (Shorthand)
        ebitda: 'EBITDA', // EBITDA (Shorthand)
        cashAndShortTermInvestment: 'النقد واستثمارات قصيرة الأجل', // Cash and short-term investment (Shorthand: نقد و.ق.أ)
        totalAssets: 'إجمالي الأصول', // Total assets (Shorthand: إ.أصول)
        totalLiabilities: 'إجمالي المطلوبات', // Total liabilities (Shorthand: إ.مطلوبات)
        totalEquity: 'إجمالي حقوق الملكية', // Total equity (Shorthand: إ.ح.م)
        operatingCashFlow: 'التدفق النقدي التشغيلي', // Operating cash flow (Shorthand: ت.ن.ت)
        netCashFromInvesting: 'صافي النقد من الاستثمار', // Net cash from investing (Shorthand: ص.ن.ا)
        netCashFinancing: 'صافي النقد من التمويل', // Net cash from financing (Shorthand: ص.ن.ت)
        netChangeInCash: 'صافي التغير في النقد', // Net cash change (Shorthand: ص.ت.ن)
        freeCashFlow: 'التدفق النقدي الحر' // Free cash flow (Shorthand: ت.ن.ح)
    },
    insiders: {
        note: 'يمكن أن تشير معاملات الأسهم الداخلية إلى إشارة إيجابية أو سلبية. ' +
            'شراء المطلعين قد يشير إلى الثقة في آفاق الشركة المستقبلية. ' +
            'بيع المطلعين (بكمية كبيرة) قد يشير أو يفسر على أنه فقدان للثقة.', // Insider stock transction can signal...
        filingDate: 'تاريخ الإيداع', // Filing date
        owner: 'الاسم', // Name
        role: 'المنصب', // Role
        date: 'التاريخ', // Date
        transaction: 'المعاملة', // Transaction
        cost: 'التكلفة', // Cost
        shares: '# أسهم', // # shares
        value: 'إجمالي التكلفة', // Total cost (Shorthand: إ.ت)
        ownedShares: 'إجمالي الأسهم', // Total shares
        ownershipWorth: 'قيمة الملكية الإجمالية', // Total ownership worth (Shorthand: ق.م.إ)
        ownershipRatio: 'نسبة الملكية', // Ownership ratio (Shorthand: ن.م)
        totalBuyTransactions: '# معاملات الشراء', // # buy transactions
        totalSellTransactions: '# معاملات البيع', // # sell transactions
        clickToWatchLink: 'انقر لمشاهدة الإيداع', // Click to see the filing
        link: 'الرابط', // Link
        reportedAtDate: 'تاريخ الإيداع', // Filing date
        transactions: {
            sell: 'بيع', // Sell
            buy: 'شراء', // Buy
            option: 'ممارسة الخيارات', // Options exercise
            award: 'منحة', // Award
            gift: 'هدية', // Gift
            tax: 'ضريبة/دفع ممارسة' // Tax/exercise payment
        }
    },
    trendingStocks: {
        symbol: 'الرمز', // Symbol
        name: 'الاسم', // Name
        price: 'السعر', // Price
        sectorIndustry: 'الصناعة', // Industry
        ratingChange: 'تغير التصنيف', // Rating change
        numberOfMentions: 'عدد الذكر', // Num. of mentions
        priceChange: 'تغير %', // Change %
        toTheFullList: 'مشاهدة القائمة الكاملة', // See the full list
        label: 'الرائجة على وسائل التواصل' // Trending on social media
    },
    dailyBrief: {
        title: 'يجب أن تعرف اليوم', // You should know today
        explanation: 'معلومات ما قبل السوق وخلال اليوم يجب أن تعرفها', // Intra-day and pre-market information...
        indices: {
            title: 'أهم المؤشرات', // Top indices
            usa: 'الولايات المتحدة', // USA
            europe: 'أوروبا', // Europe
            commodities: 'السلع', // Commodities
            asia: 'آسيا', // Asia
            crypto: 'العملات المشفرة' // Crypto
        },
        selectedEarnings: {
            weeklyEarningsTitle: 'الأرباح المختارة هذا الأسبوع', // Selected earnings this week
            dailyEarningsTitle: 'الأرباح المختارة اليوم', // Selected earnings today
            seeAllEarnings: 'انقر لمشاهدة جميع الأرباح', // Click to see all earnings
            symbol: 'الرمز', // Symbol
            reportTime: 'وقت التقرير' // Report time
        },
        selectedEvents: {
            title: 'الأحداث اليومية المختارة', // Selected daily events
            name: 'الاسم', // Name
            datetime: 'التاريخ والوقت', // Date & time
            prev: 'السابق', // Prev.
            est: 'المقدَّر', // Est.
            weeklyEventsTitle: 'الأحداث الأسبوعية المختارة', // Selected weekly events
            dailyEventsTitle: 'الأحداث اليومية المختارة', // Selected daily events
            noEvents: 'لا توجد أحداث للمشاهدة', // No events to see
            date: 'التاريخ', // Date
            time: 'الوقت' // Time
        }
    },
    topTen: {
        proTitle: 'أداء السوق', // Market performance
        title: 'أفضل 10 أسهم', // Top 10 stocks
        gainers: 'الرابحين', // Gainers
        losers: 'الخاسرين', // Losers
        active: 'النشطين', // Active
        nasdaq: 'ناسداك', // Nasdaq
        sp: 'S&P500', // S&P500
        market: 'السوق بالكامل', // Entire market
        microCap: 'قيمة متناهية الصغر ( < $250M)', // Micro-Cap
        smallCap: 'قيمة صغيرة ($250M - $2B)', // Small-Cap
        midCap: 'قيمة متوسطة ($2B - $10B)', // Mid-Cap
        largeCap: 'قيمة كبيرة ($10B - $200B)', // Large-Cap
        megaCap: 'قيمة ضخمة ( > $200B)', // Mega-Cap
        sectors:
            {
                'Communication Services': 'خدمات الاتصالات',
                'Consumer Cyclical': 'السلع الاستهلاكية الدورية',
                'Energy': 'الطاقة',
                'Financial Services': 'الخدمات المالية',
                'Real Estate': 'العقارات',
                'Technology': 'التكنولوجيا',
                'Basic Materials': 'المواد الأساسية',
                'Industrials': 'الصناعات',
                'Utilities': 'المرافق',
                'Consumer Defensive': 'السلع الاستهلاكية غير الدورية',
                'Healthcare': 'الرعاية الصحية'
            }
    },
    sectors: {
        title: 'أداء القطاعات', // Sectors performance
        marketValue: 'قيمة السوق', // Mkt value (Shorthand: ق.س)
        sharesNumber: '# أسهم', // Shares # (Shorthand)
        sectorRatio: '% من القطاع', // % of sector
        changeP: 'تغير %', // Change %
        volume: 'الحجم', // Volume
        marketCap: 'ق.س', // Market Cap. (Shorthand)
        pe: 'م.أ', // P/E (Shorthand)
        performance: 'الأداء عبر الزمن', // Performance over time
        daily: 'تغير % اليومي الأخير' // Last daily % change
    },
    calendars: {
        noData: 'لم يتم العثور على بيانات', // No data was found
        selection: {
            earnings: 'الأرباح', // Earnings
            splits: 'التجزئات', // Splits
            ipos: 'الاكتتابات', // IPOs
            dividends: 'توزيعات الأرباح' // Dividends
        },
        headers: {
            symbol: 'الرمز', // Symbol
            reportTime: 'وقت التقرير', // Report time
            eps: 'ر.س', // EPS (Shorthand)
            date: 'التاريخ', // Date
            dividend: 'الأرباح', // Dividend
            exDate: 'تاريخ الاستحقاق', // Ex-date (Shorthand: ت.استحقاق)
            payableDate: 'تاريخ الدفع', // Payable date (Shorthand: ت.دفع)
            ratio: 'النسبة', // Ratio
            sharesOffered: 'الأسهم المطروحة', // Shares offered
            ipoPrice: 'سعر الاكتتاب', // IPO price
            sharesValue: 'قيمة الأسهم', // Shares value
            exchange: 'البورصة' // Exchange
        },
        dates: {
            lastWeek: 'الأسبوع الماضي', // Last week
            past7Days: 'آخر 7 أيام', // Past 7 days
            yesterday: 'أمس', // Yesterday
            today: 'اليوم', // Today
            tomorrow: 'غداً', // Tomorrow
            thisWeek: 'هذا الأسبوع', // This week
            next7Days: 'الـ 7 أيام القادمة', // Next 7 days
            nextWeek: 'الأسبوع القادم', // Next week
            thisMonth: 'هذا الشهر', // This month
            nextMonth: 'الشهر القادم' // Next month
        },
        labels: {
            all: 'الكل', // All
            myWatchlistOnly: 'قائمة المتابعة فقط', // Watchlist only
            preMarket: 'ما قبل السوق', // Pre-Market
            afterMarket: 'ما بعد السوق' // After-Market
        }
    },
    dividends: {
        symbol: 'الرمز', // Symbol
        name: 'الاسم', // Name
        lastDivAmount: 'مبلغ الأرباح الأخير $', // Last Div. $
        lastDivPayoutDate: 'تاريخ الدفع الأخير', // Last div. payout date
        lastDivExDate: 'تاريخ الاستحقاق الأخير', // Last div. Ex-date
        nextDivAmount: 'مبلغ الأرباح القادم $', // Next div. $
        nextDivPayoutDate: 'تاريخ الدفع القادم', // Next div. payout date
        nextDivExDate: 'تاريخ الاستحقاق القادم', // Next div. Ex-date
        consecutiveYears: 'سنوات دفع متتالية', // Consecutive years pay
        consecutiveYearsGrowth: 'سنوات نمو متتالية', // Consecutive years growth
        industry: 'الصناعة', // Industry
        sector: 'القطاع', // Sector
        marketCap: 'ق.س', // Market cap. (Shorthand)
        oneYearGrowth: 'نمو الأرباح سنة', // 1Y dividend growth
        threeYearGrowth: 'نمو الأرباح 3 سنوات', // 3Y dividend growth
        fiveYearGrowth: 'نمو الأرباح 5 سنوات', // 5Y dividend growth
        tenYearGrowth: 'نمو الأرباح 10 سنوات', // 10Y dividend growth
        payoutRatio: 'نسبة التوزيع', // Payout ratio (Shorthand: ن.ت)
        payoutFrequency: 'تكرار الدفع', // Payout frequency
        yield: 'العائد' // Yield
    }
}